import React, { useMemo } from 'react'
import _ from 'lodash'
import pluralize from 'pluralize'
import Switch from 'react-switchery'
import IconField from '../../components/form/IconField'
import InputField from '../../components/form/InputField'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { useForm, useField } from 'react-form'
import '../../assets/css/pages/class_management/students-form.css'

function FieldWithIcon(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <IconField {...props} input={getInputProps()} />
}

function Field(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <InputField {...props} input={getInputProps()} />
}

const StudentsForm = props => {
  const { isSubmitting, errors, onChangeAutoGenerate, formValues, autoGenerate, onSubmit } = props
  const { Form, values, pushFieldValue, removeFieldValue, reset } = useForm({
    defaultValues: useMemo(()=>formValues, []),
    onSubmit: (values,instance)=>onSubmit(values, reset)
  })

  const handleAddStudent = ()=> pushFieldValue('studentProfiles', {})
  const handleRemoveStudent = index => removeFieldValue('studentProfiles', index)

  return(
    <div>
      <div className='row student-form-header'>
        <p className='new-student-count'>{pluralize('New Student', (values.studentProfiles || []).length, true)}</p>
        <div className='auto-gen-container'>
          <Switch
            className="switch-class"
            name='autogen'
            type='checkbox'
            onChange={onChangeAutoGenerate}
            options={{size: 'large', color: '#674ea7' }}
            checked={autoGenerate}
          />
          <p>Auto-generate usernames and <br/>passwords for new students: <b>{autoGenerate ? 'On' : 'Off'}</b></p>
        </div>
      </div>

      <Form className='students-form'>
        {_.map(values.studentProfiles, (student,index) =>
          <div key={'student'+index} className='student'>
            <div className='row'>
              <div className='col-md-5 no-padding'>
                <Field
                  name={`studentProfiles[${index}].firstName`}
                  type='text'
                  placeholder='Required'
                  label='First Name'
                />
              </div>
              <div className='col-md-5 no-padding'>
                <Field
                  name={`studentProfiles[${index}].lastName`}
                  type='text'
                  label='Last Name'
                />
              </div>
              <button type='button' className='btn btn-danger delete' onClick={()=>handleRemoveStudent(index)}>X</button>
            </div>
            {!autoGenerate &&
              <div className='row'>
                <div className='col-md-5 no-padding'>
                  <FieldWithIcon
                    name={`studentProfiles[${index}].username`}
                    type='text'
                    placeholder='Username'
                  />
                </div>
                <div className='col-md-5 no-padding'>
                  <FieldWithIcon
                    name={`studentProfiles[${index}].password`}
                    type='password'
                    placeholder='Password'
                  />
                </div>
              </div>
            }
          </div>
        )}

        <br/>
        {!_.isEmpty(errors) && <div className='error'>{errors.join(',')}</div>}
        <button className='btn btn-success' type="button" onClick={handleAddStudent}>
          Add Student
        </button>
        <br/><br/>
        <button disabled={isSubmitting} className='btn btn-primary' type="submit">Save</button>
        {isSubmitting && <img style={{maxWidth:'40px'}} className='loading-gif' src={loadingGif}/>}
      </Form>
    </div>
  )
}

export default StudentsForm
